import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIHoverActionController} from './UIHoverActionController'
import {UIGameActionButtonViewKnightActions} from '../ui_game_actions/UIGameActionButtonViewKnightActions'
import {MechanicValidatorKnightActions} from '@colonist/game-mechanic-validators'

export class UIKnightActionHoverActionController extends UIHoverActionController {
    private readonly knightActionValidator: MechanicValidatorKnightActions

    constructor(uiGameManager: UIGameManager, knightActionValidator: MechanicValidatorKnightActions) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = []
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmSelectKnightToTakeAction(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.shouldHideOnSpecialBuildPhase = true
        this.knightActionValidator = knightActionValidator
    }

    protected updateState() {
        const playerColor = this.uiGameManager.gameController.myColor
        const action = this.knightActionValidator.canPlayerTakeKnightAction(playerColor)
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameActionButtonViewKnightActions.getMoveKnightTextureForColor(this.uiGameManager.gameController.myColor, this.uiGameManager.gameController.isPlayerSpectator)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getBankActionAmount(index: number): number | undefined {
        return undefined
    }
}
